export const PRESENTATION_LANGUAGE_STORAGE_KEY = 'smartpcmh.leads-report.presentation-language';

const COPY = {
  en: {
    localeTag: 'en-US',
    reportEyebrow: 'AI Leads Report',
    snapshot: 'Snapshot',
    viewLabel: 'Dashboard view',
    generalView: 'General view',
    priorityOrder: 'Priority order',
    languageLabel: 'Presentation language',
    hideTopbar: 'Hide top bar',
    showTopbar: 'Show top bar',
    executiveSummary: 'Executive summary',
    dashboardCounters: 'Dashboard counters',
    dashboardFilters: 'Dashboard filters',
    openThreads: 'Open threads',
    hot: 'Hot',
    watchlist: 'Watchlist',
    gettingColder: 'Getting colder',
    onHold: 'On hold',
    incompletePriority: 'Incomplete priority',
    showAllOpenThreads: 'Show all open thread leads',
    filterHot: 'Filter leads by HOT section',
    filterWatchlist: 'Filter leads by Watchlist section',
    filterGettingColder: 'Filter leads by Getting COLDER section',
    filterOnHold: 'Filter leads by On hold section',
    incompletePriorityHelp: 'Open leads missing one or more priority fields',
    company: 'Company',
    allCompanies: 'All companies',
    contact: 'Contact',
    allContacts: 'All contacts',
    product: 'Product',
    allProducts: 'All products',
    search: 'Search',
    searchPlaceholder: 'Organization, contact, action...',
    visibleLead: '{count} visible lead',
    visibleLeads: '{count} visible leads',
    noMatchesTitle: 'No leads match these filters',
    noMatchesMessage: 'Try changing the company, contact, product, or search text.',
    section: 'Section',
    leads: 'Leads',
    leadCount: '{count} lead',
    leadsCount: '{count} leads',
    copyLeadAria: 'Copy {organization} details to clipboard',
    copyLeadTitle: 'Copy lead details',
    leadCopied: 'Lead data copied',
    unableToCopy: 'Unable to copy lead data',
    leadHealth: 'Lead health',
    guidanceConsidered: 'Guidance considered',
    score: 'Score',
    statusDetails: 'Status details',
    channel: 'Channel',
    active: 'Active',
    meeting: 'Meeting',
    nextAction: 'Next action',
    latestUpdate: 'Latest update',
    latestNote: 'Latest note',
    summary: 'Summary',
    messagePreview: 'Message preview',
    revenuePotential: 'Revenue/strategic potential',
    interest: 'Interest',
    valuesAlignment: 'Values alignment',
    priority: 'Priority',
    rank: 'Rank',
    unknown: 'unknown',
    loadingSupplemental: 'Loading watchlist and on-hold leads...',
    supplementalError: '{section} could not be loaded: {message}',
    loadingTitle: 'Loading leads report',
    loadingMessage: 'Preparing the dashboard snapshot...',
    buildingTitle: 'Your dashboard is being prepared',
    buildingMessage: 'You can leave this tab open. It will update automatically when the report is ready.',
    awaitingPublicationTitle: 'Dashboard ready for publication',
    awaitingPublicationMessage: 'The report finished processing but requires operational review before publication.',
    buildFailedTitle: 'Dashboard generation failed',
    buildFailedMessage: 'The report could not be generated. No incomplete dashboard was published.',
    buildCancelledTitle: 'Dashboard generation cancelled',
    buildCancelledMessage: 'This report was cancelled before publication.',
    buildStagePreparing: 'Preparing report',
    buildStageSource: 'Preparing report data',
    buildStageGenerate: 'Generating dashboard content',
    buildStageFinalize: 'Finalizing and publishing',
    buildPercent: '{percent}% complete',
    buildProgress: '{completed} of {total} leads processed',
    buildProgressAria: 'Dashboard generation progress',
    reconnectingTitle: 'Reconnecting to the dashboard',
    reconnectingMessage: 'The connection was interrupted. We will keep trying automatically.',
    offlineMessage: 'This device is offline. Monitoring will resume automatically when the connection returns.',
    invalidLinkTitle: 'Invalid dashboard link',
    notFoundTitle: 'Dashboard snapshot not found',
    unableTitle: 'Unable to load dashboard',
    dateUnavailable: 'Date unavailable',
    generated: 'Generated',
    unknownOrganization: 'Unknown organization',
    unknownContact: 'Unknown contact',
    unknownProduct: 'Unknown product',
    reviewManually: 'Review manually',
    openWhatsApp: 'Open WhatsApp',
    openEmail: 'Open email',
    healthHealthy: 'Healthy',
    healthWatch: 'Watch',
    healthAtRisk: 'At risk',
    healthBlocked: 'Blocked',
    healthUnknown: 'Health unknown',
    missingEmailMessage: 'Email address is missing.',
    missingEmailTooltip: 'Add an email address to allow sending a message to this lead.',
    missingPhoneMessage: 'Phone number is missing.',
    missingPhoneTooltip: 'Add a WhatsApp-capable number to enable WhatsApp outreach.',
    missingContactMessage: 'Contact information is incomplete.',
    missingContactTooltip: 'Add an email address or a WhatsApp-capable phone number to enable outreach.',
    missingKeyMessage: 'This lead is missing key information.',
    missingEmail: 'email address',
    missingPhone: 'phone number',
    missingContact: 'contact name',
    missingOrganization: 'company name',
    missingProduct: 'product name',
    sectionLabels: {
      hot: 'Hot',
      getting_colder: 'Getting colder',
      watchlist: 'Watchlist',
      on_hold_threads: 'On hold',
    },
  },
  es: {
    localeTag: 'es-PR',
    reportEyebrow: 'Reporte de leads con IA',
    snapshot: 'Corte',
    viewLabel: 'Vista del dashboard',
    generalView: 'Vista general',
    priorityOrder: 'Orden de prioridad',
    languageLabel: 'Idioma de presentación',
    hideTopbar: 'Ocultar barra superior',
    showTopbar: 'Mostrar barra superior',
    executiveSummary: 'Resumen ejecutivo',
    dashboardCounters: 'Contadores del dashboard',
    dashboardFilters: 'Filtros del dashboard',
    openThreads: 'Conversaciones abiertas',
    hot: 'HOT',
    watchlist: 'Lista de seguimiento',
    gettingColder: 'Enfriándose',
    onHold: 'En espera',
    incompletePriority: 'Prioridad incompleta',
    showAllOpenThreads: 'Mostrar todos los leads con conversaciones abiertas',
    filterHot: 'Filtrar leads de la sección HOT',
    filterWatchlist: 'Filtrar leads de la lista de seguimiento',
    filterGettingColder: 'Filtrar leads que se están enfriando',
    filterOnHold: 'Filtrar leads en espera',
    incompletePriorityHelp: 'Leads abiertos sin uno o más campos de prioridad',
    company: 'Compañía',
    allCompanies: 'Todas las compañías',
    contact: 'Contacto',
    allContacts: 'Todos los contactos',
    product: 'Producto',
    allProducts: 'Todos los productos',
    search: 'Buscar',
    searchPlaceholder: 'Organización, contacto, acción...',
    visibleLead: '{count} lead visible',
    visibleLeads: '{count} leads visibles',
    noMatchesTitle: 'Ningún lead coincide con estos filtros',
    noMatchesMessage: 'Prueba cambiando la compañía, el contacto, el producto o el texto de búsqueda.',
    section: 'Sección',
    leads: 'Leads',
    leadCount: '{count} lead',
    leadsCount: '{count} leads',
    copyLeadAria: 'Copiar los datos de {organization} al portapapeles',
    copyLeadTitle: 'Copiar datos del lead',
    leadCopied: 'Datos del lead copiados',
    unableToCopy: 'No fue posible copiar los datos del lead',
    leadHealth: 'Salud del lead',
    guidanceConsidered: 'Guía considerada',
    score: 'Puntuación',
    statusDetails: 'Detalles del estado',
    channel: 'Canal',
    active: 'Actividad',
    meeting: 'Reunión',
    nextAction: 'Próxima acción',
    latestUpdate: 'Última actualización',
    latestNote: 'Última nota',
    summary: 'Resumen',
    messagePreview: 'Vista previa del mensaje',
    revenuePotential: 'Potencial de ingresos/estratégico',
    interest: 'Interés',
    valuesAlignment: 'Alineación de valores',
    priority: 'Prioridad',
    rank: 'Posición',
    unknown: 'desconocido',
    loadingSupplemental: 'Cargando leads de seguimiento y en espera...',
    supplementalError: 'No fue posible cargar {section}: {message}',
    loadingTitle: 'Cargando reporte de leads',
    loadingMessage: 'Preparando el corte del dashboard...',
    buildingTitle: 'Estamos preparando tu dashboard',
    buildingMessage: 'Puedes dejar esta pestaña abierta. Se actualizará automáticamente cuando el reporte esté listo.',
    awaitingPublicationTitle: 'Dashboard listo para publicación',
    awaitingPublicationMessage: 'El reporte terminó de procesarse, pero requiere revisión operativa antes de publicarse.',
    buildFailedTitle: 'No fue posible generar el dashboard',
    buildFailedMessage: 'El reporte no pudo generarse. No se publicó ningún dashboard incompleto.',
    buildCancelledTitle: 'Generación del dashboard cancelada',
    buildCancelledMessage: 'Este reporte fue cancelado antes de publicarse.',
    buildStagePreparing: 'Preparando reporte',
    buildStageSource: 'Preparando datos del reporte',
    buildStageGenerate: 'Generando contenido del dashboard',
    buildStageFinalize: 'Finalizando y publicando',
    buildPercent: '{percent}% completado',
    buildProgress: '{completed} de {total} leads procesados',
    buildProgressAria: 'Progreso de generación del dashboard',
    reconnectingTitle: 'Reconectando con el dashboard',
    reconnectingMessage: 'La conexión se interrumpió. Seguiremos intentando automáticamente.',
    offlineMessage: 'Este dispositivo está sin conexión. El monitoreo continuará automáticamente cuando regrese.',
    invalidLinkTitle: 'Enlace del dashboard inválido',
    notFoundTitle: 'No se encontró el corte del dashboard',
    unableTitle: 'No fue posible cargar el dashboard',
    dateUnavailable: 'Fecha no disponible',
    generated: 'Generado',
    unknownOrganization: 'Organización desconocida',
    unknownContact: 'Contacto desconocido',
    unknownProduct: 'Producto desconocido',
    reviewManually: 'Revisar manualmente',
    openWhatsApp: 'Abrir WhatsApp',
    openEmail: 'Abrir correo',
    healthHealthy: 'Saludable',
    healthWatch: 'En observación',
    healthAtRisk: 'En riesgo',
    healthBlocked: 'Bloqueado',
    healthUnknown: 'Salud desconocida',
    missingEmailMessage: 'Falta la dirección de correo.',
    missingEmailTooltip: 'Agrega un correo para poder enviar un mensaje a este lead.',
    missingPhoneMessage: 'Falta el número de teléfono.',
    missingPhoneTooltip: 'Agrega un número compatible con WhatsApp para contactar al lead.',
    missingContactMessage: 'La información de contacto está incompleta.',
    missingContactTooltip: 'Agrega un correo o un teléfono compatible con WhatsApp para contactar al lead.',
    missingKeyMessage: 'A este lead le falta información clave.',
    missingEmail: 'correo electrónico',
    missingPhone: 'número de teléfono',
    missingContact: 'nombre del contacto',
    missingOrganization: 'nombre de la compañía',
    missingProduct: 'nombre del producto',
    sectionLabels: {
      hot: 'HOT',
      getting_colder: 'Enfriándose',
      watchlist: 'Lista de seguimiento',
      on_hold_threads: 'En espera',
    },
  },
};

export function normalizePresentationLanguage(value) {
  return String(value || '').toLowerCase().startsWith('es') ? 'es' : 'en';
}

export function getInitialPresentationLanguage() {
  try {
    const stored = window.localStorage.getItem(PRESENTATION_LANGUAGE_STORAGE_KEY);
    if (stored === 'es' || stored === 'en') {
      return stored;
    }
  } catch (_ignored) {
    // localStorage is optional presentation state and can be unavailable.
  }

  return normalizePresentationLanguage(typeof navigator === 'undefined' ? 'en' : navigator.language);
}

export function persistPresentationLanguage(language) {
  try {
    window.localStorage.setItem(PRESENTATION_LANGUAGE_STORAGE_KEY, normalizePresentationLanguage(language));
  } catch (_ignored) {
    // A blocked localStorage must never prevent the dashboard from rendering.
  }
}

export function getPresentationCopy(language) {
  return COPY[normalizePresentationLanguage(language)];
}

export function formatPresentationCopy(template, values = {}) {
  return String(template || '').replace(/\{(\w+)\}/g, (_match, key) => (
    Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : `{${key}}`
  ));
}

export function localizedPresentationText(presentation, language, field, fallback) {
  const normalizedLanguage = normalizePresentationLanguage(language);
  const localized = presentation && typeof presentation === 'object'
    ? presentation[normalizedLanguage]
    : null;
  const aliases = field === 'summary_markdown' ? ['summary_markdown', 'summary'] : [field];
  const localizedValue = aliases
    .map((key) => localized?.[key])
    .find((value) => typeof value === 'string' && value.trim());

  return localizedValue || fallback;
}
